import { render } from "./BrowserLanguageDropdown.vue?vue&type=template&id=75458584&scoped=true"
import script from "./BrowserLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./BrowserLanguageDropdown.vue?vue&type=script&lang=js"

import "./BrowserLanguageDropdown.vue?vue&type=style&index=0&id=75458584&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75458584"]])

export default __exports__